/** Mensagem amigável para falhas de sessão/perfil (PostgREST, JWT, etc.). */
export function mensagemErroAuth(raw: string): string {
  const msg = raw.toLowerCase()
  if (msg.includes('issued at future') || msg.includes('jwt')) {
    return (
      'Relógio do computador ou do Supabase local dessincronizado (JWT inválido). ' +
      'Sincronize a hora do Windows, reinicie o Supabase local (supabase stop / start), ' +
      'saia do sistema, limpe o armazenamento do site e entre novamente.'
    )
  }
  if (msg.includes('401') || msg.includes('unauthorized') || msg.includes('invalid claim')) {
    return 'Sessão expirada ou inválida. Saia e entre novamente.'
  }
  return raw
}

export function mensagemErroNecessidadePedido(raw: string): string {
  const msg = raw.toLowerCase()
  if (
    msg.includes('statement timeout') ||
    msg.includes('57014') ||
    msg.includes('canceling statement')
  ) {
    return (
      'Cálculo da necessidade demorou demais (timeout). ' +
      'Aplique a migration 20261020120000_necessidade_pedido_security_definer.sql no Postgres local ' +
      'e tente novamente.'
    )
  }
  if (msg.includes('prato_id') && msg.includes('does not exist')) {
    return (
      'Banco local desatualizado: falta a coluna cardapios.prato_id. ' +
      'Aplique as migrations 20261009110000 e 20261020100000 (scripts/apply-migration.mjs).'
    )
  }
  if (msg.includes('necessidade_pedido_periodo') && msg.includes('does not exist')) {
    return (
      'Função necessidade_pedido_periodo não encontrada. ' +
      'Aplique a migration 20261019100000_compras_periodo_pedido.sql no Postgres local.'
    )
  }
  if (msg.includes('401') || msg.includes('jwt')) {
    return mensagemErroAuth(raw)
  }
  return raw
}
